
import { Link } from "react-router-dom";
import "./commercial.css";
import React, { useEffect, useRef, useState } from "react";
import SideBareMagasin from "../SideBareMagasin/SideBareMagasin";
import FilterMagasin from "../HomeMagasin/mobile-magasin/FilterMagasin";
// import "./CommandeProcess.css";
const CommandeProcess: React.FC = () => {

  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
  };
  // Convert to percentage for visual positioning
  const getPercent = (value: number) => Math.round((value / 500000) * 100);

  // Set width of the range to decrease from the left side

  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    website: "",
    coverLetter: "",
    resume: "",
  });
  const [step, setStep] = useState(1);

  const nextStep = () => setStep((prev) => prev + 1);
  const prevStep = () => setStep((prev) => prev - 1);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    alert("Commande submitted!");
    console.log(formData);
  };
  const handleGoBack = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };
  return ( 
  <>
    <SideBareMagasin/>
  <div className="contenu-Magasinmobile">
          <div
            className="up-title-background-admin"
            style={{ padding: "2% 5%" }}
          >
            <div
              style={{
                width: "100%",
                marginLeft:"-7%",
                display: "flex",
                alignItems: "center",
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "#a2a2a2",
                borderRadius:"4px",
                marginTop:"6%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  height: "40px",
                  backgroundColor: "white",
                  
                }}
              >
                <input
                  type="search"
                  // onChange={handleSearch}
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    padding: "0 10px",
                    borderRadius: "4px",
                    outline: "none",
                    color: "black",
                    
                  }}
                  placeholder="Chercher un produit..."
                />
                <i className="bi bi-search" style={{ marginRight: "10px" }}></i>
              </div>
              <i
                className="bi bi-sliders filter-icon"
                style={{ marginLeft: "10px", cursor: "pointer" }}
                onClick={toggleFilter}
              ></i>
              {/* model filter  */}
              {/* <FilterMagasin isOpen={isFilterOpen} onClose={toggleFilter} /> */}

            </div>
          </div>
        </div>
        </>
  
  
)
}
export default CommandeProcess;

